import type { ToolChangeEventArgs } from '@thive/canvas';

export const shouldResetFlowStoreOnToolChange = (e: ToolChangeEventArgs): boolean => {
  if (e.from !== 'Draw.LineSticky') return false;

  // Middle mouse can temporarily switch tools (e.g. Pan/Orbit/Walk).
  if (e.to === 'Pan' || e.to === 'Orbit' || e.to === 'Walk') return false;

  return true;
};